import { checkauth } from '../Helper';

const SearchLogs = () => import('../views/searchlogs/Index.vue');
const SynonymCreate = () => import('../views/searchlogs/SynonymCreate.vue');
const SynonymEdit = () => import('../views/searchlogs/SynonymEdit.vue');

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [
	{ path: '/ecommerce/searches', name: 'searchlogs', component: SearchLogs, beforeEnter: guard },
	{ path: '/ecommerce/searches/synonyms/new', name: 'searchsynonyms-new', component: SynonymCreate, beforeEnter: guard },
	{ path: '/ecommerce/searches/synonyms/:id([0-9a-fA-F]{24})', name: 'searchsynonyms-edit', component: SynonymEdit, beforeEnter: guard },
];
